module.exports = __webpack_public_path__ + "img/1568831306.c9ac8701.jpg";